import { FileText, Database, Search, AlertCircle } from "lucide-react";

const NoDataAvailable = ({ 
  message = "No data available", 
  variant = "default",
  className = "",
}) => {
  // Variant configurations
  const variants = {
    default: {
      icon: <Database className="w-10 h-10 text-gray-400" />,
      bgColor: "bg-gray-50",
      textColor: "text-gray-500",
    },
    search: {
      icon: <Search className="w-10 h-10 text-blue-400" />,
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
    },
    error: {
      icon: <AlertCircle className="w-10 h-10 text-red-400" />,
      bgColor: "bg-red-50",
      textColor: "text-red-600",
    },
    document: {
      icon: <FileText className="w-10 h-10 text-purple-400" />,
      bgColor: "bg-purple-50",
      textColor: "text-purple-600",
    },
  };

  const currentVariant = variants[variant] || variants.default;

  return (
    <div className={`flex flex-col items-center justify-center min-h-[50vh] p-8 rounded-lg ${currentVariant.bgColor} ${className}`}>
      <div className="mb-4">
        {currentVariant.icon}
      </div>
      <h3 className={`text-lg font-medium ${currentVariant.textColor}`}>
        {message}
      </h3>
    </div>
  );
};

export default NoDataAvailable;